var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-page"},[_c('h5',[_vm._v("Bem vindo ao TOPTIC GO")])])
}]

export { render, staticRenderFns }